import { createBrowserClient } from "@supabase/ssr"
import { authCookieOptions, shouldPersistSession } from "@/lib/supabase/cookie-options"

let supabaseClient: ReturnType<typeof createBrowserClient> | null = null

export function createClient() {
  if (supabaseClient) {
    return supabaseClient
  }

  supabaseClient = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      // Persist the auth-token cookies across browser restarts (unless the
      // user explicitly opted out via "Remember me"). Without an explicit
      // maxAge these become session cookies and users get logged out every
      // time they close the browser / the installed PWA.
      // No custom auth lock: since auth-js 2.117 the client coordinates
      // session refreshes without one and never touches navigator.locks, which
      // is what the old in-memory lock existed to avoid. Passing one now only
      // logs a deprecation warning.
      cookieOptions: authCookieOptions(shouldPersistSession()),
    },
  )

  return supabaseClient
}

export { createClient as createBrowserClient }
